import React from 'react';
import {
  Background,
  Content,
  PeopleMagicProfitLogoContainer,
  ProfitSalesAnnouncementContainer,
  TextBlock,
} from './ProfitSalesAnnouncement.styles';
import { useStaticQuery, graphql } from 'gatsby';
import { IStaticContentfulImages } from 'src/types/contentful';
import { GatsbyImage } from 'gatsby-plugin-image';
import Heading from 'src/elements/typography/heading';
import { palette } from 'src/styles/colors';
import Paragraph from 'src/elements/typography/paragraph';
import LinkBranded from 'src/elements/links/2023_Q4/LinkBranded';
import Arrow from 'src/images/Arrow';
import { usePeopleMagicDesignController } from 'src/hooks/usePeopleMagicDesignController';

const ProfitSalesAnnouncement = (): JSX.Element => {
  const { background, joinNowImage } = useStaticQuery<IStaticContentfulImages>(graphql`
    {
      background: contentfulAsset(contentful_id: { eq: "1GjC1obr909KGNxuUnFhky" }) {
        gatsbyImageData(width: 1440, layout: CONSTRAINED, placeholder: BLURRED)
      }
      joinNowImage: contentfulAsset(contentful_id: { eq: "bXuJ6RpFdFHRfMYWZXLL4" }) {
        gatsbyImageData(width: 1440, layout: CONSTRAINED, placeholder: BLURRED)
      }
    }
  `);

  const { homepage } = usePeopleMagicDesignController();
  const linkSlug = homepage?.peopleMagicProfitAnnouncementLinkSlug || '/peoplemagic';
  const hasAlternativeCopy = homepage?.hasPeopleMagicAdvertisementMovedToTop;

  return (
    <ProfitSalesAnnouncementContainer>
      <Background>
        <GatsbyImage
          image={background.gatsbyImageData}
          alt=''
        />
      </Background>
      <Content>
        <PeopleMagicProfitLogoContainer>
          <GatsbyImage
            image={joinNowImage.gatsbyImageData}
            alt=''
          />
        </PeopleMagicProfitLogoContainer>

        <TextBlock>
          <Heading
            text={!hasAlternativeCopy ? 'Build a $1M Community' : 'What if it was EASY?'}
            align='left'
            color={palette.white}
            standardSize='2.125'
          />
          <Paragraph
            standardSize='1.125'
            text={
              !hasAlternativeCopy
                ? 'What if there were just 9 SIMPLE STEPS to creating a community so valuable it could generate $1M in revenue and 99% profit margins with AI?'
                : `At Mighty Networks, we don’t just give you amazing software – powered by AI - to run your community and courses. \n\nWe also hand you a proven strategy for FREE. And when you see it?  You’re going to ask yourself, “why didn’t I do this sooner?”`
            }
            align='left'
            color={palette.white}
          />
          <LinkBranded
            text={!hasAlternativeCopy ? 'Unlock the FREE Masterclass' : 'Yes, I want the easiest way to launch'}
            url={linkSlug}
            colorScheme='Sunshine'
            customBorderRadius={300}
            customFontWeight={700}
            icon={
              <Arrow
                width={13}
                color='greyText'
              />
            }
          />
        </TextBlock>
      </Content>
    </ProfitSalesAnnouncementContainer>
  );
};

export default ProfitSalesAnnouncement;
